import { computed } from 'vue';
import { useProfile } from './profile';

export const useUserType = () => {
  const { userRoles } = useProfile();

  const userType = computed(() => {
    if (userRoles.isFamilyUser) return 'family';
    if (userRoles.isPartnerAdmin) return 'partner';
    if (userRoles.isAffiliateUser) return 'affiliate';
    return 'operator'; // default for operator roles
  });

  return {
    userType,
  };
};
